/* @ngInject */
export default function routes($stateProvider) {
  $stateProvider
    .state('main.cases.new', {
      url: '/new',
      template: '<new></new>',
    });
}



// WEBPACK FOOTER //
// ./client/app/cases/new/new.routes.js